import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  SEND_RESET_PASSWORD_EMAIL,
  SEND_RESET_PASSWORD_EMAIL_FAIL,
  SEND_RESET_PASSWORD_EMAIL_SUCCESS,
  SendResetPasswordEmailActionType
} from '../redux/authReducer'

function* SendResetPasswordLinkFlow(action: SendResetPasswordEmailActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      endpoint: '/tutors/tutors/send_reset_password_email',
      method: 'POST',
      params: { email: action.payload.email }
    })
    yield put(SEND_RESET_PASSWORD_EMAIL_SUCCESS(response))
  } catch (error) {
    yield put(SEND_RESET_PASSWORD_EMAIL_FAIL())
    console.log(error)
  }
}

export default function* SendResetPasswordLinkSaga(): Generator<any, void, any> {
  yield takeLatest([SEND_RESET_PASSWORD_EMAIL], SendResetPasswordLinkFlow)
}
